import HttpInterface from '../infra/http/HttpInterface';
import ParticipantServiceInterface, {
  ParticipantInput,
} from './interfaces/ParticipantServiceInterface';

export default class ParticipantService implements ParticipantServiceInterface {
  constructor(readonly httpClient: HttpInterface, readonly baseUrl: string) {}

  async addParticipant(model: ParticipantInput): Promise<any> {
    return this.httpClient.request(
      `${this.baseUrl}/api/participant/add`,
      model,
      'post'
    );
  }
  async removeParticipant(model: ParticipantInput): Promise<any> {
    return this.httpClient.request(
      `${this.baseUrl}/api/participant/remove`,
      model,
      'post'
    );
  }
}
